import {
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    DialogActions,
    Button,
    Box
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import axiosClient from "../../../../../../lib/axios";
import { useMutation, useQueryClient } from "react-query";
import { INotaFiscal } from "../../../../../../types/api/fiscal/detalhe-nfe-entrada";

export function DialogRecusarNotaFiscal({
    open,
    handleClose,
    fiscal,
    onSuccess: handleSuccess
}: DialogRecusarNotaFiscalProps) {

    const queryClient = useQueryClient();

    const [motivo, setMotivo] = useState('');

    //queries e mutations
    const { mutate: recusar, isLoading } = useMutation({
        mutationKey: "emitir-pix",
        mutationFn: (inputs: TParamsRecusarNotaFiscal) => {
            return axiosClient.post(`/fiscal/aprovacao-fiscal`, inputs);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['nota-fiscal', fiscal.id]);
            enqueueSnackbar('Nota fiscal recusada com sucesso!', { variant: 'success' });
            handleSuccess();
        },
    });

    // handlers
    const handleSubmit = async () => {
        if (motivo.trim()) {
            const params: TParamsRecusarNotaFiscal = {
                id: fiscal.id,
                fluxo: 'recusar',
                motivo: motivo,
            }
            recusar(params);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>Motivo da Recusa</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2, mb: 3 }}>
                    <TextField
                        autoFocus
                        multiline
                        rows={6}
                        fullWidth
                        variant="outlined"
                        placeholder="Descreva o motivo da recusa..."
                        value={motivo}
                        onChange={(e) => setMotivo(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: 'primary.main',
                                },
                            },
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 0 }}>
                <Button
                    onClick={handleClose}
                    variant="outlined"
                    color="primary"
                    disabled={isLoading}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={!motivo.trim() || isLoading}
                >
                    Confirmar Recusa
                </Button>
            </DialogActions>
        </Dialog>
    );
}

interface DialogRecusarNotaFiscalProps {
    open: boolean;
    handleClose: () => void;
    fiscal: INotaFiscal;
    onSuccess: () => void;
}

type TParamsRecusarNotaFiscal = {
    id: number;
    fluxo: string;
    motivo: string;
}